import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';


export default function Conditions(props) {
    const { options, values, handleChangeCondition } = props
    const { selects, radios, switches, texts } = options

    const handleChangeSwitch = (name) => {
        handleChangeCondition(name, !values[name])
    }

    const handleChangeRadio = (name, value) => {
        handleChangeCondition(name, value)
    }

    const handleChangeSelect = (e) => {
        const name = e.target.name;
        var value = e.target.value;
        handleChangeCondition(name, value)
    }

    return (
        <Grid container item md={12} xs={12}>
            {
                radios.map((item) => {
                    const { name, items } = item
                    return (
                        <FormControl component="fieldset">
                            <FormLabel component="legend">{name}</FormLabel>
                            <RadioGroup row aria-label="gender" name={name} value={values[name]} onChange={(e) => handleChangeRadio(name, e.target.value)}>
                                {
                                    items.map((item) => {
                                        return <FormControlLabel key={`condition-radio-${name}-${item}`}value={item} control={<Radio />} label={item} />
                                    })
                                }
                            </RadioGroup>
                        </FormControl>
                    )
                })
            }
            {
                switches.map((item) => {
                    return (
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={values[item]}
                                    onChange={(e) => handleChangeSwitch(item)}
                                    value={item}
                                    color="primary"
                                />
                            }
                            label={item}
                        />
                    )
                })
            }
            {
                selects.map(item => {
                    return (
                        <FormControl fullWidth>
                            <InputLabel id="options-thumbnailPosition">{item.name}</InputLabel>
                            <Select
                                fullWidth
                                labelId="options-thumbnailPosition-label"
                                value={values[item.name]}
                                name={item.name}
                                onChange={handleChangeSelect}
                            >
                                {
                                    item.items.map(i => {
                                        return <MenuItem value={i}>{i}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    )
                })
            }
            {
                texts.map((item) => {
                    return (
                        <TextField
                            onChange={(e) => handleChangeSelect(e)}
                            name={item}
                            label={item}
                            value={values[item]}
                            fullWidth
                        />
                    )
                })
            }
            {/* <FormControlLabel
                    control={
                        <Checkbox
                            checked={infinite}
                            onChange={() => this.handleChangeOptions("trim_space")}
                            name="trim_space"
                            color="primary"
                        />
                    }
                    label="スペースの削除"
                /> */}
        </Grid>
    )
}